import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["TheAccountDropdown"], {
    "account-dropdown-class": "text-capitalize my-0 py-0 secondary--font d-none d-md-flex account-dropdown",
    "is-loading": $setup.isLoading,
    accounts: $setup.activeAccounts,
    "selected-account-id": $setup.userStore.getAccountId,
    "onUpdate:selectedAccountId": _cache[0] || (_cache[0] = ($event: any) => (($setup.userStore.getAccountId) = $event)),
    "default-account-name": $setup.userStore.getDefaultAccount?.name || 'Select Account',
    "search-string": $setup.searchText,
    "onUpdate:searchString": _cache[1] || (_cache[1] = ($event: any) => (($setup.searchText) = $event)),
    onAccountChange: $setup.handleAccountChange,
    onLoadmore: $setup.loadMoreAccounts,
    onSearchChange: $setup.handleSearchChange,
    showLoadMore: $setup.haveMoreAccounts,
    disableAccountDropdown: $setup.route.meta.disableAccountDropdown
  }, null, 8 /* PROPS */, ["is-loading", "accounts", "selected-account-id", "default-account-name", "search-string", "showLoadMore", "disableAccountDropdown"]))
}